import { EmptyApiState } from "./EmptyApiState";
import { FileCheck2, KeyRound, ShieldCheck } from "lucide-react";

export function SettingsTab() {
  return (
    <div className="grid gap-4 md:grid-cols-3">
      <EmptyApiState
        title="AppleSeed token"
        description="Manage the AppleSeed for IT token used to receive beta seeding."
        icon={<KeyRound className="h-5 w-5" aria-hidden="true" />}
      />
      <EmptyApiState
        title="Approval gates"
        description="Configure who must approve major OS updates before rollout."
        icon={<ShieldCheck className="h-5 w-5" aria-hidden="true" />}
      />
      <EmptyApiState
        title="Generated declarations"
        description="Auto-generated declarative software update profiles from your policies."
        icon={<FileCheck2 className="h-5 w-5" aria-hidden="true" />}
      />
    </div>
  );
}

export default SettingsTab;
